module.exports = __webpack_public_path__ + "static/media/Club_Tijuana.0565a6d9.png";